<template lang="pug">
    component.square(:is="tag" v-bind="props" :class="{ highlight }") {{ square.title }}
</template>

<script>
import _ from 'lodash'

export default {
    name: 'Square',
    props: {
        square: {
            type: Object,
            required: true
        }
    },
    computed: {
        tag() {
            let tag = 'div';
            if (this.path) tag = 'router-link';
            else if (this.href) tag = 'a';
            return tag;
        },
        props() {
            let props = {};

            switch (this.tag) {
                case 'a':
                    props.href = this.href;
                    props.target = this.target;
                    break;

                case 'router-link':
                    props.to = this.path;
                    break;
            }

            return props;
        },
        highlight() {
            let highlight = false

            const settings = _.get(this.square, 'settings') || []
            const setting = settings.find(el => el.key === 'highlight')

            if (setting) highlight = ['true', '1', 'yes', true].includes(setting.value)
            return highlight
        },
        hyperlink() {
            return _.get(this.square, 'hyperlink') || {};
        },
        href() {
            let href = false;

            if (this.hyperlink.type !== 'internal' && _.get(this.hyperlink, 'href')) {
                const link = this.hyperlink.href;
                switch (this.hyperlink.type) {
                    case 'external':
                        if (!link.startsWith('https://') && !link.startsWith('http://')) href = `https://${link}`;
                        else href = link;
                        break;

                    case 'mailto':
                        href = `mailto:${link}`;
                        break;

                    case 'tel':
                        href = `tel:${link}`;
                        break;
                }
            }

            return href;
        },
        target() {
            return _.get(this.hyperlink, 'target') || '_self';
        },
        path() {
            if (this.hyperlink.type === 'internal' && _.get(this.hyperlink, 'menuItem.path'))
                return this.hyperlink.menuItem.path;
            else return false;
        },
    }
}
</script>

<style lang="sass" scoped>
@import "~@/assets/sass/variables";

#app
    .square
        font-size: 1.8rem
        background: $black
        color: $white
        display: flex
        justify-content: center
        align-items: center
        text-transform: initial
        font-weight: bold
        border: 6px solid $black
        transition: background .15s ease, color .15s ease
        &.highlight
            margin: 0
            background: $white
            color: $black
    a.square:hover
        background: $white
        color: $black
    &.dark
        .square
            border: 6px solid $white
            background: $white
            color: $black
            &.highlight
                background: $black
                color: $white
        a.square:hover
            background: $black
            color: $white
</style>
